import { Inject, Injectable } from '@angular/core';
import {
    PdfViewerDesktopService,
    PdfViewerDialogInput,
} from '../../../projects/kiene-core/src/lib/components/pdf-viewer/kiene-pdf-viewer/kiene-pdf-viewer-desktop/pdf-viewer-desktop.service';
import { HttpParams } from '@angular/common/http';
import { of, Subject } from 'rxjs';
import { HeimtierBeleg, HeimtierBelegBezahlstatus } from './heimtier-beleg';
import { ConfirmDialogComponent } from '../../../projects/kiene-core/src/lib/components/dialogs/confirm-dialog/confirm-dialog.component';
import {
    ConfirmDialogInput,
    ConfirmDialogResult,
} from '../../../projects/kiene-core/src/lib/components/dialogs/confirm-dialog/confirm-dialog';
import { MatDialog } from '@angular/material/dialog';
import { KieneBackendApiService } from '../../../projects/kiene-core/src/lib/services/backend-api/kiene-backend-api.service';
import { API_BASE_URL_SERVICE } from '../../../projects/kiene-core/src/lib/kiene-core.config';
import { HeimtierBezahlungDialogComponent } from './heimtiere-startseite/heimtier-bezahlung-dialog/heimtier-bezahlung-dialog.component';
import { Router } from '@angular/router';
import { MessageService } from '../../../projects/kiene-core/src/lib/services/message-service/message.service';

@Injectable({ providedIn: 'root' })
export class HeimtiereService {
    constructor(
        @Inject(API_BASE_URL_SERVICE) private readonly apiBaseUrl: string,
        private readonly pdfService: PdfViewerDesktopService,
        private readonly api: KieneBackendApiService,
        private readonly messageService: MessageService,
        private readonly router: Router,
        private readonly dialog: MatDialog,
    ) {}

    rechnungAnzeigenBeleg(beleg: HeimtierBeleg) {
        if (beleg?.pdf_id_rechnung) {
            const subject = new Subject<boolean>();
            const input = new PdfViewerDialogInput(
                'rechnung/read_or_mail_pdf.php',
                new HttpParams().set('rechnung_id', beleg?.rechnung_id?.toString()),
                'Rechnung',
                { email: { sende_mail: true, kunde_id: beleg?.kunde_id } },
            );
            input.isInvoice = true;
            this.pdfService.openPdfViewer(input).subscribe({
                next: () => {
                    subject.next(true);
                },
            });
            return subject;
        }
        return of(true);
    }

    rechnungErstellen(beleg: HeimtierBeleg) {
        const input = new ConfirmDialogInput();
        input.headline = 'Rechnung erstellen';
        input.text = 'Möchten Sie die Rechnung wirklich erstellen?';
        input.okButton = 'Ja';
        input.cancelButton = 'Nein';
        this.dialog
            .open(ConfirmDialogComponent, { data: input })
            .afterClosed()
            .subscribe({
                next: (response: ConfirmDialogResult) => {
                    if (response?.ok) {
                        this.abrechnen(beleg);
                    }
                },
            });
    }

    private abrechnen(beleg: HeimtierBeleg) {
        this.api.post(this.apiBaseUrl + 'heimtier_beleg/abrechnen.php', beleg).subscribe({
            next: (hke: HeimtierBeleg) => {
                this.rechnungAnzeigenBeleg(hke).subscribe({
                    next: () => {
                        this.openBezahlDialog(hke);
                    },
                });
            },
            error: err => {
                this.messageService.errorMessage('Fehler beim Erstellen der Rechnung', err);
            },
        });
    }

    private openBezahlDialog(htk: HeimtierBeleg) {
        this.dialog
            .open(HeimtierBezahlungDialogComponent, { data: htk })
            .afterClosed()
            .subscribe({
                next: result => {
                    if (result) {
                        const hbb = new HeimtierBelegBezahlstatus();
                        hbb.bezahlt = result === 'überweisung' ? 0 : 1;
                        hbb.hk_id = htk.hk_id;
                        hbb.rechnung_id = htk.rechnung_id;
                        this.api.post(this.apiBaseUrl + 'heimtier_kalendereintrag/bezahlstatus.php', hbb).subscribe({
                            next: () => {
                                this.messageService.infoMessage('Bezahlung gespeichert');
                                this.router.navigate(['heimtiere', 'startseite']).then();
                            },
                            error: err => {
                                this.messageService.errorMessage('Fehler beim Speichern der Bezahlung', err);
                            },
                        });
                    } else {
                        this.router.navigate(['heimtiere', 'startseite']).then();
                    }
                },
            });
    }
}
